import { JsonObject, JsonProperty } from 'json2typescript';
import constants from '../common/constants';

interface GraphSettingOption {
  contentType?: string;
}

@JsonObject('GraphSettingOptions')
class GraphSettingOptions {
  public static create(options: GraphSettingOption) {
    return Object.assign(new GraphSettingOptions(), {
      contentType: options.contentType || constants.TECH_WRITER_GRAPH_CONTENT_TYPE,
    });
  }
  @JsonProperty('contentType', String, true)
  // @ts-expect-error TS2322 - strict migration
  contentType: string = undefined;
}

export default GraphSettingOptions;
